const constants = {
  baseURL: "https://api.cexdirect.com/",
  defaultPlacementId: "d9d1630d-be98-4c2c-aa69-3b9163c79107",
};

export default constants;
